import React from 'react';
import { Badge } from 'react-bootstrap';
export default function UserAccessBusinessUnitBadges(_ref) {
  var _userAccess$user_acce, _userAccess$user_acce2;
  let {
    userAccess
  } = _ref;
  if (!(userAccess !== null && userAccess !== void 0 && (_userAccess$user_acce = userAccess.user_access_business_unit_participations) !== null && _userAccess$user_acce !== void 0 && _userAccess$user_acce.length)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return (_userAccess$user_acce2 = userAccess.user_access_business_unit_participations) === null || _userAccess$user_acce2 === void 0 ? void 0 : _userAccess$user_acce2.map((participation, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Badge, {
      key: index,
      bg: "primary"
    }, participation.business_unit.name), ' ');
  });
}